import { FC } from 'react';
import { useNavigate } from 'react-router';
import { Heading } from './Heading';

type Props = {
  id: string;
  heroImage?: string;
  title: string;
  description?: string;
  gradientPlaceholder: string;
};

export const CampaignCard: FC<Props> = ({
  id,
  heroImage,
  title,
  description,
  gradientPlaceholder,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/client/details/campaign/${id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md cursor-pointer transition-transform transform hover:scale-[1.02] duration-300 w-full max-w-80 mx-auto"
    >
      <Heading
        mediaUrl={heroImage}
        title={title}
        gradientPlaceholder={gradientPlaceholder}
      />

      <div className="p-3 sm:p-4 flex flex-col justify-between">
        <div className="flex flex-col gap-1">
          <div className="text-base sm:text-lg font-medium line-clamp-2">
            {title}
          </div>
          <div className="text-sm text-gray-600 line-clamp-2">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};
